
import { Route, Routes } from "react-router-dom";
import Sidebar from "./sidebar.js";
import DataTable from "./farmerdata.js";
import "./dashome.css";
import DataTableEmp from "./employee.js";
import Collecttea from "./collectdata.js";
import Factory from "./factory.js";
import DashboardHome from "./dash.js";
import DailySummaryTables from "./today.js";
import DailyExpenses from "./Dailyexpense.js";
import FarmerDetails from "./farmerdetails.js";
import FarmerReport from "./formreport.js";
import AddAdvanceAmount from "./Advance.js";
import MonthlyQtyTotal from "./farmtotal.js";
import TeaAndFactoryCollection from "./today.js";
import FarmerPayment from "./farmerPayment.js";
import EmployeeDetails from "./employeedata.js";
import FactoryDataTable from "./factorydatatable.js";
import TeaCollectionReport from './formreport.js'
import FactoryReport from './reportfactory.js'
import AdvanceReport from './reportadvance.js'
import ExpensesReport from './reportexpenses.js'

function Dashome() {
  return (
    <div className="layout-container">
      <Sidebar />
      <div className="main-content">
        <Routes>
          <Route path="/" element={<DashboardHome />} />
          <Route path="/farmer" element={<DataTable />} />
          <Route path="/farmer/:id" element={<FarmerDetails />} />
          <Route path="/employee" element={<DataTableEmp />} />
             <Route path="/employee/:id" element={<EmployeeDetails/>} />
          <Route path="/collect" element={<Collecttea />} />
          <Route path="/farmreports" element={<TeaCollectionReport/>} />
            <Route path="/factoryreports" element={<FactoryReport/> } />
              <Route path="/advancereports" element={ <AdvanceReport/> } />
                <Route path="/expensesreports" element={ <ExpensesReport/>  } />


          <Route path="/advance" element={<AddAdvanceAmount />} />
          <Route path="/factorydata" element={<Factory />} />
           <Route path="/factory" element={<FactoryDataTable/>} />
          <Route path="/monthly" element={<MonthlyQtyTotal />} />
          <Route path="/today" element={<TeaAndFactoryCollection/>} />
          <Route path="/dailyexp" element={<DailyExpenses />} />
          <Route path="/payment" element={<FarmerPayment/>} />
         
        </Routes>
      </div>
    </div>
  );
}

export default Dashome;
